export const ForgotPassword = () => {
  return <div>ForgotPassword</div>;
};
